import { useEffect, useState } from "react";
import styles from "./list.module.css";
import { Button } from "@mui/material";
import { List, Map as Map1 } from "react-feather";
import DriverCard from "./DriverCard";

const MapView = ({ allData, setViewType }) => {
    const [driverList, setDriverList] = useState([]);

    useEffect(() => {
        let driverListTemp = allData?.map(i => {
            return { id: i?.driver?.id, name: i?.driver?.name, address: i?.driver?.address, lat: i?.driver?.latitude, lng: i?.driver?.longitude };
        });

        driverListTemp = [...new Map(driverListTemp.map(item => [item.id, item])).values()];

        setDriverList(driverListTemp);
    }, [allData]);

    return (<>
        <div className="TableFilterHead" style={{ flexDirection: 'row-reverse' }}>
            <div>
                <Button className={`${styles.SwitchBtn}`} onClick={(e) => setViewType('list')}><List /></Button>
                <Button className={`${styles.SwitchBtn} ${styles.SwitchBtnActive}`}><Map1 /></Button>
            </div>
        </div>

        <div>
            {driverList?.map(item => {
                return <DriverCard driver={item} allData={allData} />
            })}
        </div>
    </>);
};

export default MapView;